// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2uYwA","emails":"CreateEditClinics_emails__3TzaO","emailTagLabel":"CreateEditClinics_emailTagLabel__3iOJS"};